import { ref, computed } from 'vue'

export function useWizardSteps(steps) {
  const currentStep = ref(0)

  const canNavigateToStep = (stepIndex) => {
    return stepIndex <= currentStep.value
  }

  const goToStep = (stepIndex) => {
    if (canNavigateToStep(stepIndex)) {
      currentStep.value = stepIndex
    }
  }

  const nextStep = () => {
    if (currentStep.value < steps.length - 1) {
      currentStep.value++
    }
  }

  const previousStep = () => {
    if (currentStep.value > 0) {
      currentStep.value--
    }
  }

  const isStepActive = (stepIndex) => {
    return currentStep.value === stepIndex
  }

  const isStepCompleted = (stepIndex) => {
    return currentStep.value > stepIndex
  }

  const isStepDisabled = (stepIndex) => {
    return currentStep.value < stepIndex
  }

  return {
    currentStep,
    canNavigateToStep,
    goToStep,
    nextStep,
    previousStep,
    isStepActive,
    isStepCompleted,
    isStepDisabled
  }
}
